<sm-svg-loader *ngIf="loader"></sm-svg-loader>

<div class="dashboard_new" *ngIf="!loader && expenditureData.length == 0">
    <mat-card>
        <div class="upload_sectio">

       <div class="icm_img">
          <img src="./assets/images/s6.png">
       </div>
       <mat-card-title>Track latest business expenditures </mat-card-title>
       <mat-card-content>Keeping track of expenses helps you manage costs effectively, maintain budget. This includes costs for supplies, employee wages, utilities, and other overhead expenses.
    </mat-card-content>
       <!-- <div class="watch_vc_btn">
          <button mat-stroked-button color="primary" (click)="openvideo()">
             <mat-icon>smart_display</mat-icon>
             Watch video
          </button>
       </div> -->
       </div>
    </mat-card>
 </div>

 <!-- with data -->
 <div class="today_booking_card" *ngIf="!loader && expenditureData.length > 0">
    <mat-card>
    <div class="vier_tht">
       <div class="heading_ot"> 
       <h3>Expenditure </h3> 
      </div>
       <div class="view_all_btn" *ngIf="expenditureData[0].total_count > 4">
        <a (click)="viewAll()">{{expenditureData[0].total_count > 4 ? 'View all ' + expenditureData[0].total_count : 'View details'}}</a>
      </div>
  </div>
  <!--  -->
  <div class="list_yy" *ngFor="let item of expenditureData">
    <div class="bookign_crim">
       <mat-icon *ngIf="item.expense_type == 1">receipt</mat-icon>
       <mat-icon *ngIf="item.expense_type == 2">local_mall</mat-icon>
       <mat-icon *ngIf="item.expense_type == 3">payments</mat-icon>
    </div>
    <div class="booking_heading">
        <h3>{{item.expense_label}}</h3>
        <p> {{item.expense_detail}}</p>
    </div>
    <div class="booking_heading">
        <h3>{{item.name}}</h3>
        <p>{{item.address_line}}</p>
    </div>
    <div class="booking_heading">
        <h3>{{item.expense_datetime | date}}</h3>
        <p>{{item.expense_datetime | date : "shortTime"}}</p>
    </div>
    <div class="booking_heading">
        <h3>{{item.currency_symbol ? item.currency_symbol : ''}}{{item.amount.toFixed(2)}}</h3>
    </div>
  </div>
  <div class="list_yy" style="height: 61px;" *ngFor="let item of repeatArray">
    
  </div>
  <!-- <div class="list_yy">
    <div class="bookign_crim chnagecolorx">
       <mat-icon>shopping_cart</mat-icon>
    </div>
    <div class="booking_heading">
        <h3>Chair purchase</h3>
        <p> Aniket For 2024-06-14 To...</p>
    </div>
    <div class="booking_heading">
        <h3>Abc Beauty</h3>
        <p>Durgapur, WB</p>
    </div>
    <div class="booking_heading">
        <h3>2024-07-12</h3>
        <p>3:00 PM</p>
    </div>
    <div class="booking_heading">
        <h3>₹2190</h3>
    </div>
  </div> -->


</mat-card>

</div>

